const KEYCODE_TAB = 9;
const KEYCODE_SPACE = 32;
const KEYCODE_ENTER = 13;
const KEYCODE_ESC = 27;

/**
 * returns true if the pressed key was space
 * @param {Event} e
 * @returns
 */
export function isSpace(e) {
  return e.key === " " || e.keycode === KEYCODE_SPACE;
}

/**
 * returns true if the pressed key was tab
 * @param {Event} e
 * @returns
 */
export function isTab(e) {
  return e.key === "Tab" || e.keycode === KEYCODE_TAB;
}

/**
 * returns true if the pressed key was enter
 * @param {Event} e
 * @returns
 */
export function isEnter(e) {
  return e.key === "Enter" || e.keycode === KEYCODE_ENTER;
}

/**
 * returns true if the pressed key was 'esc'
 * @param {Event} e
 * @returns
 */
export function isEsc(e) {
  return e.key === "Escape" || e.keycode === KEYCODE_ESC;
}
